import { render, staticRenderFns } from "./openVipModal.vue?vue&type=template&id=9ceb70b4&scoped=true"
import script from "./openVipModal.vue?vue&type=script&lang=js"
export * from "./openVipModal.vue?vue&type=script&lang=js"
import style0 from "./openVipModal.vue?vue&type=style&index=0&id=9ceb70b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ceb70b4",
  null
  
)

export default component.exports